import { OfficeLocation } from "./org-chart-node"
import Branch from "./branch"
import Client from "./client"
import Employee from "./employee"

export default interface Address {
  id: string
  street1: string
  street2?: string | null
  city: string
  region?: string | null
  postalCode?: string | null
  country: string
  createdAt: Date
  updatedAt: Date
  deletedAt?: Date | null

  // Navigation
  locations?: OfficeLocation[]
  branches?: Branch[]
  clients?: Client[]
  employees?: Employee[]
}

// region/country show up as plain strings on some addresses (e.g. Client's,
// aliased server-side via raw SQL) and as { name } relation objects on others
// (e.g. OfficeLocation's, via a real Prisma include) — accept either shape
// so callers can't accidentally render the object itself.
type NameLike = string | { name: string } | null | undefined

export interface AddressLike {
  street1?: string | null
  street2?: string | null
  city?: string | null
  region?: NameLike
  postalCode?: string | null
  country?: NameLike
}

export class AddressUI {
  private static resolveName(value: NameLike): string | null {
    if (!value) return null
    return typeof value === "string" ? value : value.name ?? null
  }

  /** Builds a single-line, comma-separated display string for an address. */
  static build(address?: AddressLike | null): string {
    if (!address) return "-"

    const parts = [
      [address.street1, address.street2].filter(Boolean).join(", "),
      address.city,
      this.resolveName(address.region),
      address.postalCode,
      this.resolveName(address.country),
    ].filter(Boolean)

    return parts.length ? parts.join(", ") : "-"
  }
}
